// import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { layers } from 'app/spacing';
import { KizenTypography } from 'app/typography';
import Loader from 'components/Kizen/Loader';
import Button from 'components/Button';
import Card from 'components/Card/Card';
import { fieldMargin } from 'components/Builders/CustomFieldsBuilder/Field';
import Switch from 'components/Kizen/Switch';

export const BuilderLoader = styled(Loader)`
  padding: 100px 0 200px;
`;

export const Header = styled.div`
  width: 100%; // width set to 1372px as per design
  margin: 20px 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 46px;
`;

export const HeaderSection = styled.div``;

export const HeaderButton = styled(Button)`
  &:last-of-type {
    margin-right: 0;
  }
`;

export const PageSizing = styled.div`
  margin: 0 15px;
`;

export const BigCard = styled(Card)`
  padding-top: 15px;
  margin: 15px auto 20px;
  display: flex;
  flex-direction: column;
  > div:last-of-type {
    flex: 1;
  }
  max-width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 6px;
  h3 {
    margin-top: -1px; // Design nudge
    line-height: 1; // Sidestep bootstrap
  }
`;

export const RightHeader = styled.div`
  margin-top: -3px;
  display: flex;
  justify-content: start;
`;

export const ActivitiesTitle = styled.div`
  align-items: flex-start;
  margin-bottom: 20px;
  margin-left: 0;

  h3 {
    margin-top: 4px;
  }
  button {
    margin: 0;
  }
`;

export const ActivitiesFooter = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  margin-top: 6px;
`;

export const FooterNewFieldTypography = styled(KizenTypography)`
  align-self: flex-start;
  margin-bottom: 0px;
  margin-right: 20px;
  ${({ disabled }) => {
    if (disabled) {
      return css`
        cursor: default;
        color: var(--color-background-medium);
      `;
    }

    return css`
      cursor: pointer;
      color: var(--color-button-primary-default);
      &:hover {
        color: var(--color-button-primary-hover);
      }
    `;
  }}
`;

export const FieldLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${fieldMargin}px ${20 - fieldMargin}px;
`;

export const ItemWrapper = styled.div`
  position: relative;
  display: flex;
  ${({ width, cols }) => css`
    width: ${(100 * width) / cols}%;
  `}
  ${({ dragging, draggingFrom, optioning }) =>
    (dragging || draggingFrom || optioning) &&
    css`
      z-index: ${layers.content(0, 1)};
    `}
  ${({ dragging }) =>
    dragging &&
    css`
      pointer-events: none;
    `}
`;

export const EditTextBlockModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ObjectAssociationsContainer = styled.div`
  margin-bottom: 20px;
`;

export const ObjectAssociationsSelectorRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: flex-end;
  column-gap: 20px;
`;

// padding-bottom = (DROPDOWN_HEIGHT / 2) - (SWITCH_HEIGHT / 2) i.e. (36 / 2) - (14 / 2)
export const ObjectAssociationsSwitch = styled(Switch)`
  padding-bottom: 11px;
`;
